/**
 * searchStore — open/close state for the global search modal.
 *
 * Kept as its own tiny store (rather than local state) because the modal has
 * multiple triggers from unrelated places: the sidebar launcher button and the
 * global Cmd/Ctrl+K shortcut registered in AppShell. A store lets any of them
 * toggle it without prop-drilling through the layout.
 */

import { create } from "zustand";

interface SearchState {
  open: boolean;
  openSearch: () => void;
  closeSearch: () => void;
  toggleSearch: () => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  open: false,
  openSearch: () => set({ open: true }),
  closeSearch: () => set({ open: false }),
  toggleSearch: () => set((s) => ({ open: !s.open })),
}));
